import React from 'react';
import { Container, Row, Col, Ratio } from 'react-bootstrap';

const VideoSection = () => {
  return (
    <section
      className="video-section text-center"
      style={{
        backgroundColor: '#f8f9fa',
        padding: '80px 20px',
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Container>
        <h2 className="mb-5" style={{ fontWeight: 700 }}>
          आमचे व्हिडिओ
        </h2>

        <Row className="align-items-start">
          {/* Left Video */}
          <Col xs={12} lg={6} className="mb-5 mb-lg-0 text-center">
            <Ratio aspectRatio="16x9">
              <iframe
                src="https://www.youtube.com/embed/awHhCjPZSiQ"
                title="जीवन आधार फाऊंडेशन कार्यक्रम"
                allowFullScreen
              />
            </Ratio>
            <p className="mt-3" style={{ fontSize: '1.1rem' }}>
              जीवन आधार फाऊंडेशनच्या समाजसेवा उपक्रमांची माहिती.
            </p>
          </Col>

          {/* Right Video */}
          <Col xs={12} lg={6} className="text-center">
            <Ratio aspectRatio="16x9">
              <iframe
                src="https://www.youtube.com/embed/IoIC49-2IEA"
                title="जीवन आधार फाऊंडेशन लाईव्ह कार्यक्रम"
                allowFullScreen
              />
            </Ratio>
            <p className="mt-3" style={{ fontSize: '1.1rem' }}>
              जीवन आधार फाऊंडेशनच्या चालू सामाजिक उपक्रमांचे थेट प्रक्षेपण.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default VideoSection;
